import { configureStore } from '@reduxjs/toolkit';
import messagesReducer from './features/messagesSlice';

export const store = configureStore({
  reducer: {
    messages: messagesReducer,
  },
});

export default store;
